import { Directive } from '@angular/core';
import { RxTextareaComponent } from './rx-textarea.component';

@Directive({
	selector: '[rxTextareaSubmit]',
	standalone: true,
	host: {
		'(click)': 'onClick()'
	}
})
export class RxTextareaSubmitDirective {
	constructor(private readonly textarea: RxTextareaComponent) {}

	onClick(): void {
		this.textarea.submit();
	}
}
